import React, { createContext, useContext, useState, useEffect } from 'react';

const AdvancedFeaturesContext = createContext();

export const useAdvancedFeatures = () => {
  const context = useContext(AdvancedFeaturesContext);
  if (!context) {
    throw new Error('useAdvancedFeatures must be used within AdvancedFeaturesProvider');
  }
  return context;
};

function isInputFocused() {
  const el = document.activeElement;
  if (!el) return false;
  const tag = el.tagName.toUpperCase();
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable;
}

export const AdvancedFeaturesProvider = ({ children }) => {
  const [showAdvancedFeatures, setShowAdvancedFeatures] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key !== 'z') return;
      if (e.repeat) return;
      if (isInputFocused()) return;
      setShowAdvancedFeatures(true);
    };

    const handleKeyUp = (e) => {
      if (e.key !== 'z') return;
      setShowAdvancedFeatures(false);
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, []);

  return (
    <AdvancedFeaturesContext.Provider value={{ showAdvancedFeatures }}>
      {children}
    </AdvancedFeaturesContext.Provider>
  );
};
